/**
 * 数値文字列入力フィールド（文字数範囲あり）
 * @param props
 * @returns
 */
const InputNumTextRange = ({ val, min, max, onChange }) => {
  return (
    <input
      type="text"
      value={val}
      pattern={`[0-9]{${min}, ${max}}`}
      maxLength={max}
      size={max}
      onChange={e => onChange(e.target.value.replace(/[^0-9]/g, ""))}
      required
    />
  );
};
export default InputNumTextRange;
